import { render } from "./PointsList.vue?vue&type=template&id=3b40ea99&scoped=true"
import script from "./PointsList.vue?vue&type=script&lang=js"
export * from "./PointsList.vue?vue&type=script&lang=js"

import "./PointsList.vue?vue&type=style&index=0&id=3b40ea99&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b40ea99"]])

export default __exports__